__turbopack_context__.v({
  "aiTranslationDisclaimer": "style-module-scss-module__AfHRQW__aiTranslationDisclaimer",
  "component": "style-module-scss-module__AfHRQW__component",
  "description": "style-module-scss-module__AfHRQW__description",
  "extras": "style-module-scss-module__AfHRQW__extras",
});
